export * from '@primeuix/themes/lara/splitbutton';
export { default } from '@primeuix/themes/lara/splitbutton';
